/** @format */
import { jwtDecode } from 'jwt-decode';

export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (e) {
    return false;
  }
};

export const AUTH_TOKEN_KEY = 'authToken';

export const LAST_ACTIVITY_KEY = 'lastActivity';

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const getLastActivity = () => {
  const raw = localStorage.getItem(LAST_ACTIVITY_KEY);
  const value = Number(raw);

  return Number.isFinite(value) && value > 0 ? value : null;
};

export const setLastActivity = (timestamp = Date.now()) => {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(timestamp));
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem('USER_DETAILS');
  localStorage.removeItem(LAST_ACTIVITY_KEY);
};

export default isTokenValid;
